var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"questions\">\n<div class=\"questions__question\" ng-class=\"{active: question === create.currentQuestion}\" ng-click=\"create.setQuestion($index)\" ng-repeat=\"question in create.questions\">{{question[create.currentLanguage][0]}}</div>\n</div>\n";
var id1="create/template/tabContentQuestion.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;